import { TechDimensions } from "../dimensions/TechDimensions";
import { GeoDimensions } from "../dimensions/GeoDimensions";
import { SessionDimensions } from "../dimensions//SessionDimensions";
import { UserDimensions } from "../dimensions/UserDimensions";
import AppConfig from "../../app-config";
import { ActionDimensions } from "../dimensions/ActionDimensions";
import { DEFAULT_VALUE, LoggingScreenNames } from "../types/LoggingTypes";
import { getCookies } from "../helpers/commonCookiesFunctions";
const useLogging = () => {
    //remove any stored logging values if the use was away for more than one minute
    var _a, _b, _c;
    const config = AppConfig.getConfig();
    GeoDimensions.getInstance().geoAppCountry = config.authenticationData.country;
    const userId = (config && config.authenticationData && config.authenticationData.userInfo && config.authenticationData.userInfo.id) ? config.authenticationData.userInfo.id.toString() : DEFAULT_VALUE;
    UserDimensions.getInstance().userMemberId = userId;
    const device_uuid = getCookies().device_uuid;
    UserDimensions.getInstance().userTrackingId = (device_uuid !== undefined && device_uuid.length > 0) ? device_uuid : DEFAULT_VALUE;
    TechDimensions.getInstance().language = (_a = config.lang) !== null && _a !== void 0 ? _a : DEFAULT_VALUE;
    TechDimensions.getInstance().version = (config.loggingChatConfig && config.loggingChatConfig.version) ? (_b = config.loggingChatConfig) === null || _b === void 0 ? void 0 : _b.version : DEFAULT_VALUE;
    SessionDimensions.getInstance().sessionId = (_c = getCookies().tgtTicket) !== null && _c !== void 0 ? _c : DEFAULT_VALUE;
    ActionDimensions.getInstance().currScreen = LoggingScreenNames['chats'];
};
export { useLogging };
